export const UPLOAD_LABELS = {
  dragAndDrop: 'Drag and drop files here or',
  uploadingFiles: 'Uploading files...',
  passwordPlaceholder: 'Password',
  uploadFailed: 'Upload failed',
  deleteFile: 'Delete file',
  notFoundResponse: 'Not Found',
} as const
